import {Key} from 'util/Key'
import React from 'react'

export function getNextCursor(evt: React.KeyboardEvent<any>, cursor: number | null, maxIndex: number) {
	let nextCursor: number | null = null
	switch (evt.key) {
		case Key.Up:
			if (cursor === null || cursor <= 0) {
				nextCursor = maxIndex
			} else {
				nextCursor = cursor - 1
			}
			break;
		case Key.Down:
			if (cursor === null || cursor >= maxIndex) {
				nextCursor = 0
			} else {
				nextCursor = cursor + 1
			}
			break;
		case Key.Shift:
			return cursor
	}
	return nextCursor
}